// Strikte feste Plätze (Team-Entscheid 2026-07-30): borderBadges (Sprache und
// 2D/3D, kommt aus separateNewsletterAttributes) stehen IMMER als Chips
// angeschnitten auf der oberen Pillen-Kante; textAttributes (Atmos, HDR,
// Neustart, …) stehen IMMER als Textzeilen unter der Pille. Kein Auffüllen,
// keine Kappung — Infos springen nie zwischen oben und unten.
//
// Chips stehen AUSSERHALB der Zeit-Pille (inline im Pill-Span brechen sie bei
// 14%-Zellbreite um und sprengen die Zelle) und werden via relative/top:4px
// leicht auf die Pillen-Oberkante gezogen. Clients ohne position (Gmail/
// Outlook): Chip sitzt bündig auf der Pille — kein Loch, kein Layoutbruch.
// Die Pille darf selbst NICHT positioniert sein, sonst übermalt sie die Chips.
const wrapperStyle = {
  display: "inline-block",
  textAlign: "left",
}

const badgeRowStyle = {
  display: "block",
  textAlign: "left",
  lineHeight: "16px",
}

const badgeShift = {
  position: "relative",
  top: "4px",
}

// Icon-Grafik im Chip; alt = Attributname als Fallback, wenn der Client
// Bilder blockt (dann erscheint der Name als Text wie beim Text-Chip).
// width/height kommen pro Icon mit (Outlook braucht beide Attribute).
const badgeIconStyle = {
  display: "inline-block",
  verticalAlign: "middle",
  border: "0",
}

const PerformanceTimeEntry = ({ href, showtime, borderBadges, textAttributes, styles }) => {
  // Uniformer Pillen-Offset: mit Chips liefert die 16px-Chip-Zeile den Abstand
  // (marginTop 0), ohne ersetzt ihn ein 16px-Margin — Pille sitzt in jeder
  // Zelle gleich hoch, Uhrzeiten bleiben über die Tage auf einer Höhe
  const pillStyle = borderBadges.length > 0
    ? { ...styles.time, marginTop: 0 }
    : { ...styles.time, marginTop: "16px" }
  return (
    <a href={href} style={styles.link} target="_blank">
      <span style={wrapperStyle}>
        {borderBadges.length > 0 &&
          <span style={badgeRowStyle}>
            {borderBadges.map(attr => (
              <span key={attr.id} style={{ ...styles.attributeInline, ...badgeShift }}>
                {attr.iconUrl
                  ? <img src={attr.iconUrl} alt={attr.name} width={attr.iconWidth} height={attr.iconHeight} style={badgeIconStyle} />
                  : attr.name}
              </span>
            ))}
          </span>
        }
        <span style={pillStyle}>{showtime}</span>
        {textAttributes.map(attr => (
          <span key={attr.id} style={styles.attributeText}>
            {attr.iconUrl
              ? <img src={attr.iconUrl} alt={attr.name} width={attr.iconWidth} height={attr.iconHeight} style={badgeIconStyle} />
              : attr.name}
          </span>
        ))}
      </span>
    </a>
  )
}

export default PerformanceTimeEntry
